export default __webpack_public_path__ + "static/media/FAQ_6_1.c8c90c23.png";